import { INDICATORS } from "../../configs/constants";
import { withCommas, treeTypesByAbbr } from "../../helpers";
import { getScore } from "../Scenario/helpers";
import { Blockgroup } from "../../types";

export const getTotalCover = (blockgroup: Blockgroup) => {
  let acresAdded = 0;
  const currentCanopy = blockgroup[INDICATORS.TREE_CANOPY.field] * 0.000247105;
  acresAdded = blockgroup.acresAdded || 0;
  if (currentCanopy && acresAdded > 0) {
    return (currentCanopy + acresAdded).toFixed();
  } else {
    return "-";
  }
};

export const getTesChange = (blockgroup: Blockgroup) => {
  const currentTes = blockgroup[INDICATORS.TREE_EQUITY_SCORE.field];
  const tesGoal = getScore(blockgroup) || 0;
  if (currentTes && tesGoal > 0) {
    return `+ ${(tesGoal - currentTes).toFixed()}`;
  } else {
    return "-";
  }
};

export const getSpecificBenefit = (scenario, benefit: string) => {
  let total = 0;
  for (let i = 0; i < scenario.municipalities.length; i++) {
    let municipality = scenario.municipalities[i];
    for (let j = 0; j < municipality.blockgroups.length; j++) {
      let blockgroup = municipality.blockgroups[j];
      const species = treeTypesByAbbr.get(blockgroup.treeType || "BDM");
      let numberOfTrees =
        (blockgroup.acresAdded || 0) / (species.AreaSF / 43560);
      total += numberOfTrees * species[benefit] || 0;
      if (blockgroup.parcels) {
        for (let k = 0; k < blockgroup.parcels.length; k++) {
          let parcel = blockgroup.parcels[k];
          const species = treeTypesByAbbr.get(parcel.treeType || "BDM");
          let numberOfTrees =
            (parcel.acresAdded || 0) / (species.AreaSF / 43560);
          total += numberOfTrees * species[benefit] || 0;
        }
      }
      if (blockgroup.features) {
        for (let k = 0; k < blockgroup.features.length; k++) {
          let drawn_area = blockgroup.features[k];
          const species = treeTypesByAbbr.get(
            drawn_area.properties.treeType || "BDM"
          );
          let numberOfTrees =
            (drawn_area.properties.treesAdded || 0) / (species.AreaSF / 43560);
          total += numberOfTrees * species[benefit] || 0;
        }
      }
    }
  }
  if (
    benefit === "CO2Annual" ||
    benefit === "CO2Total25" ||
    benefit === "RainAnnual" ||
    benefit === "CoolingAnnual" ||
    benefit === "HeatingAnnual"
  ) {
    return withCommas(total);
  }
  return withCommas(total, 3);
};

export const getTotalTrees = (scenario) => {
  let total = 0;
  for (let i = 0; i < scenario.municipalities.length; i++) {
    let municipality = scenario.municipalities[i];
    for (let j = 0; j < municipality.blockgroups.length; j++) {
      let blockgroup = municipality.blockgroups[j];
      let bgtotal = blockgroup.acresAdded || 0;
      let ptotal = 0;
      if (blockgroup.parcels) {
        for (let k = 0; k < blockgroup.parcels.length; k++) {
          let parcel = blockgroup.parcels[k];
          ptotal += parcel.acresAdded || 0;
        }
      }

      if (blockgroup.features) {
        for (let k = 0; k < blockgroup.features.length; k++) {
          let drawn_area = blockgroup.features[k];
          const species = treeTypesByAbbr.get(
            drawn_area.properties.treeType || "BDM"
          );
          ptotal += drawn_area.properties.treesAdded / species.AreaSF || 0;
        }
      }
      total += Math.max(bgtotal, ptotal);
    }
  }
  return withCommas(total);
};
